/**
 * React Query Provider for V4 Dashboard
 */

import React from 'react'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { dashboardQueryClient } from './query-client'

interface DashboardQueryProviderProps {
  children: React.ReactNode
}

export function DashboardQueryProvider({
  children,
}: DashboardQueryProviderProps) {
  return (
    <QueryClientProvider client={dashboardQueryClient}>
      {children}
      <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />
    </QueryClientProvider>
  )
}
